import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { faqs } from '../data/site';

const { FiPlus, FiMinus } = FiIcons;

function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-ink/15">
      {faqs.map((f, i) => (
        <div key={f.q} className="border-b border-ink/15">
          <button
            type="button"
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-6 py-6 text-left"
          >
            <span className="h-display text-2xl md:text-3xl">{f.q}</span>
            <SafeIcon icon={open === i ? FiMinus : FiPlus} className="shrink-0 text-xl text-brick" />
          </button>
          {open === i && <p className="max-w-2xl pb-7 text-sm leading-7 text-stone">{f.a}</p>}
        </div>
      ))}
    </div>
  );
}

export default Faq;
